<template>
  <div class="image-uploaded-wrapper">
    <div class="overlay-layer">
      <Button class="edit-image-button" @click="editImageHandler">{{ $t("edit_image") }}</Button>
    </div>
    <img :src="imageSrc" class="uploaded-image-preview" />
  </div>
</template>

<script>
import { $eventHub } from "@/components";
import { EventConstraints } from "@/enums/events.enum";
export default {
  props: {
    imageSrc: {
      type: String,
      default: () => "",
    },
  },

  methods: {
    /***
     * @returns {void}
     * Emits the edit event to open the edit dialog
     */
    editImageHandler() {
      $eventHub.$emit(EventConstraints.EDIT_IMAGE_EVENT);
    },
  },
};
</script>

<style lang="scss" src="./styles.scss" scoped />
